function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import ChartModel from "./ChartModel.js";
import { defaultChartTheme } from "./ChartTheme.js";
import ChartUtils from "./ChartUtils.js";
/** Displays a basic random chart */
class MockChartModel extends ChartModel {
  static get theme() {
    /* eslint-disable no-underscore-dangle */
    if (MockChartModel._theme == null) {
      MockChartModel._theme = defaultChartTheme();
    }
    return MockChartModel._theme;
    /* eslint-enable no-underscore-dangle */
  }
  static makeRandomSeries(offset) {
    var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var steps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var dates = [];
    var values = [];
    var smooth = [];
    var linear = [];

    // Setting to a fixed seed date so that e2e tests can be deterministic.
    var startDate = new Date('2018-06-01');
    for (var i = 0; i < steps; i += 1) {
      var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i - steps);
      dates.push("".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate()));
      var v = (Math.sin(i / steps * offset) * steps / 3 + Math.cos(i * 0.2) * steps / 6 + Math.sin(i * 0.5) * steps / 10 + MockChartModel.random() * steps / 5 + i * MockChartModel.smoothing) * scale;
      v = Math.round(v * 100) / 100; // 2 decimals only
      // using steps acts as amplititude scaling based on value
      // large sine wave for course shape  + small sine waves for bumpiness +
      // general randomness noise + index to be constantly up and to the right + smoothing factor
      values.push(v);
      linear.push(40 + i * MockChartModel.smoothing);
      smooth.push(Math.sin(i / steps * offset) * steps / 3 + MockChartModel.random() * steps / 10 + i * MockChartModel.smoothing); // push a smoother version of the same thing
    }
    return {
      x: dates,
      y: values,
      s: smooth,
      l: linear
    };
  }
  static makeScatter(series) {
    return {
      name: 'SCTR',
      x: series.x,
      y: series.y,
      type: 'scatter',
      mode: 'markers',
      hoverinfo: 'skip',
      marker: {
        size: 5
      }
    };
  }
  static makeArea(series) {
    return {
      name: 'AREA',
      x: series.x,
      y: series.s,
      type: 'scatter',
      mode: 'line',
      fill: 'tozeroy',
      hoverinfo: 'all',
      line: {
        width: 3
        // area patten gets applied as hack in post render plot.ly callback + css
      }
    };
  }
  static makeTrendline(series) {
    return {
      // we probably want to toss the line formula in legend I guess? either that or render it as text manually on plot
      name: 'Trendline <br>R<sup>2</sup> = 0.91',
      x: series.x,
      y: series.l,
      type: 'scatter',
      mode: 'line',
      hoverinfo: 'skip',
      line: {
        width: 3,
        dash: 'dot' // trendlines should follow some sort of color convention + dots/dashed. Remember there can multiple
        // chroma(c.$green).brighten(1.2).hex()
      }
    };
  }
  static makeErrorBand(series) {
    // generate continouous error bands values and text
    var erroryforward = [];
    var errorybackward = [];
    for (var i = 0; i < series.y.length; i += 1) {
      var value = series.y[i];
      erroryforward[i] = Math.round((value + 18) * 100) / 100;
      errorybackward[i] = Math.round((value - 18) * 100) / 100;
    }

    // makes a closed shape of points winding clockwise for y values
    var errory = erroryforward.concat(errorybackward.reverse());
    return {
      name: 'error',
      x: series.x.concat(series.x.slice().reverse()),
      // winding for x values, that slice just clones so reverse doesn't apply inplace
      y: errory,
      type: 'scatter',
      mode: 'line',
      hoverinfo: 'skip',
      fill: 'toself',
      // there's some ordering bug with scattergl where if the areas traces are ordered after the lines they don't render
      line: {
        width: 0,
        color: MockChartModel.theme.error_band_line_color,
        shape: 'spline'
      }
    };
  }
  static makeLine(series) {
    return {
      name: 'LINE',
      x: series.x,
      y: series.y,
      type: 'scatter',
      mode: 'line',
      hoverinfo: 'x+y+text+name',
      line: {
        width: 3
      }
    };
  }
  static makeRandomData() {
    var series1 = MockChartModel.makeRandomSeries(6);
    var areaPattern = MockChartModel.makeArea(series1);
    var trendLine = MockChartModel.makeTrendline(series1);
    var series2 = MockChartModel.makeRandomSeries(2);
    var line = MockChartModel.makeLine(series2);
    var errorBand = MockChartModel.makeErrorBand(series2);
    return [areaPattern, trendLine, line, errorBand];
  }
  static makeDefaultLayout(dh) {
    var layout = {
      template: new ChartUtils(dh).makeDefaultTemplate(MockChartModel.theme)
    };
    layout.title = {
      text: 'Chart'
    };
    layout.xaxis = {
      title: {
        text: 'Datestamp'
      }
    };
    layout.yaxis = {
      title: {
        text: 'Price'
      }
    };
    return layout;
  }
  constructor(dh) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? MockChartModel.makeRandomData() : _ref$data,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? MockChartModel.makeDefaultLayout(dh) : _ref$layout,
      _ref$filterFields = _ref.filterFields,
      filterFields = _ref$filterFields === void 0 ? [] : _ref$filterFields;
    super(dh);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "filterFields", void 0);
    _defineProperty(this, "layout", void 0);
    this.data = data;
    this.layout = layout;
    this.filterFields = filterFields;
  }
  getData() {
    return this.data;
  }
  getLayout() {
    return this.layout;
  }
  getFilterColumnMap() {
    var map = new Map();
    for (var i = 0; i < this.filterFields.length; i += 1) {
      var name = this.filterFields[i];
      var type = 'java.lang.String';
      map.set(name, {
        name,
        type
      });
    }
    return map;
  }
  isFilterRequired() {
    return this.filterFields.length > 0;
  }
  setFilter() {
    this.fireUpdate(this.data);
  }
}
_defineProperty(MockChartModel, "random", Math.random.bind(Math));
_defineProperty(MockChartModel, "smoothing", 1.5);
_defineProperty(MockChartModel, "_theme", void 0);
export default MockChartModel;
//# sourceMappingURL=MockChartModel.js.map